var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-page',{attrs:{"id":"app"}},[_c('v-ons-navigator',{attrs:{"swipeable":"","page-stack":_vm.pageStack,"options":{animation: 'slide'}},on:{"pop":function($event){return _vm.pageStack.pop()},"push":function($event){_vm.pageStack = _vm.pageStack.concat( [$event])},"replace":function($event){_vm.pageStack = _vm.pageStack.slice(0, -1).concat( [$event])}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c7105e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 